/**
 * `/cases/new` — raise a case.
 *
 * One `RouteObject`, so the file is `new.route.tsx` (singular). It sits beside
 * `/cases/:id` in the router table and must be registered BEFORE it: `new` and
 * a ULID are both single segments, and a dynamic segment declared first would
 * swallow the literal one.
 */
import type { RouteObject } from 'react-router-dom';

export const newCaseRoute: RouteObject = {
  path: 'cases/new',
  lazy: async () => {
    const { NewCasePage } = await import('./NewCasePage');
    return { Component: NewCasePage };
  },
};
